const phrases = [
    "Uncompromising Quality",
    "Bespoke Post-Production",
    "Cinematic Mastery",
    "High-Ticket Visual Assets",
    "Structured Craft",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {phrases.map((p) => (
            <span key={p} className="flex items-center">
                <span className="whitespace-nowrap px-14 font-serif text-xl italic text-[#270057] md:text-2xl">
                    {p}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 border border-[#270057]/40" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="marquee-mask overflow-hidden py-12"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
